import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { updateSurfacePalette } from '@primeng/themes';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {

    
}
